<template>
  <div>
    <div v-if="paymentRent.payableReceivable && Object.keys(paymentRent.payableReceivable).length > 0">
      <Alert type="info">
        <span>
          Conta vinculada, sua alteração resultará em uma modificação no <b>Financeiro</b>.
        </span>
      </Alert>
    </div>
    <b-row v-if="status == 2 && !paymentRent.id">
      <b-col sm="12">
        <RadioGroup title="Lançar no Financeiro?" :formName="formName" field="group" :options="[
          { text: 'Sim', value: true },
          { text: 'Não', value: false },
        ]" v-model="paymentRent.registerInFinance" />
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="9">
        <Select title="Tipo de Pagamento" field="typePayment" :required="true" :markFormDirty="false"
          :propsParams="{ any: 'Rental' }" v-model="paymentRent.typePayment"
          url="/api/v1/finance/type-payment/select-all" :showNewRegister="hasRule('Rental')"
          nameNewRegister="typePaymentCreateUpdate" titleNewRegister="Tipo de Pagamento" :widthNewRegister="500"
          :heightNewRegister="250">
          <TypePaymentCreateUpdate :registerInSelect="true" v-model="paymentRent.typePayment" />
        </Select>
      </b-col>
      <b-col sm="3">
        <InputDecimal title="Valor" field="value" :formName="formName" :required="true" :markFormDirty="false"
          :maxLength="5" type="float" v-model="paymentRent.value" />
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="3">
        <DateTime title="Vencimento" field="dueDate" format="DD/MM/YYYY" type="date" placeholder :formName="formName"
          :required="true" v-model="paymentRent.dueDate" />
      </b-col>
      <b-col sm="9">
        <InputText title="Descrição" field="name" :formName="formName" :required="false" :maxLength="200"
          v-model="paymentRent.description" :markFormDirty="false" />
      </b-col>
    </b-row>

    <RepeatPayment v-if="!paymentRent.id" :payment="paymentRent" v-model="reapeter" />
    <b-row>
      <b-col sm="12">
        <div class="text-right">
          <Button _key="btnSavePaymentRent" type="success" title="Salvar" :disabled="!isFormValid(formName)"
            classIcon="fas fa-save" size="medium" :clicked="savePaymentRent" />
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import InputText from "@nixweb/nixloc-ui/src/component/forms/InputText";
import InputDecimal from "@nixweb/nixloc-ui/src/component/forms/InputDecimal";
import DateTime from "@nixweb/nixloc-ui/src/component/forms/DateTime";
import Button from "@nixweb/nixloc-ui/src/component/forms/Button";
import CheckboxGroup from "@nixweb/nixloc-ui/src/component/forms/CheckboxGroup";
import CheckboxSimple from "@nixweb/nixloc-ui/src/component/forms/CheckboxSimple";
import Select from "@nixweb/nixloc-ui/src/component/forms/Select";
import Alert from "@nixweb/nixloc-ui/src/component/layout/Alert";
import PaymentRent from "@/components/modules/rental/payment-rent/PaymentRent.js";
import TypePaymentCreateUpdate from "../../finance/type-payment/TypePaymentCreateUpdate.vue";
import RepeatPayment from "@/components/modules/shared/payment-items/RepeatPayment";
import RadioGroup from "@nixweb/nixloc-ui/src/component/forms/RadioGroup";

import { mapGetters, mapActions, mapMutations } from "vuex";

export default {
  name: "PaymentRentCreateUpdate",
  components: {
    InputText,
    InputDecimal,
    DateTime,
    Select,
    Button,
    RadioGroup,
    CheckboxGroup,
    CheckboxSimple,
    TypePaymentCreateUpdate,
    Alert,
    RepeatPayment
  },
  props: {
    rentId: String,
    status: Number,
  },
  data() {
    return {
      formName: "paymentRentCreateUpdate",
      paymentRent: new PaymentRent(),
      urlCreate: "/api/v1/rental/payment-rent/create",
      urlUpdate: "/api/v1/rental/payment-rent/update",
      reapeter: [],
    };
  },
  computed: {
    ...mapGetters("validation", ["isFormValid"]),
    ...mapGetters("generic", ["event"]),
    ...mapGetters("user", ["hasRule"]),
  },
  methods: {
    ...mapActions("generic", ["postApi", "putApi"]),
    ...mapMutations("generic", [
      "removeLoading",
      "removeEvent",
      "hideModal",
      "hideVodal",
    ]),
    ...mapMutations("validation", ["resetValidation"]),
    savePaymentRent() {
      this.paymentRent.rentId = this.rentId;
      this.paymentRent.status = this.status;

      if (this.paymentRent.id) {
        let params = { url: this.urlUpdate, obj: this.paymentRent };
        this.putApi(params).then((response) => {
          if (response.success) this.hideModal();
          this.removeLoading(["btnSavePaymentRent"]);
        });
      } else {
        let params = { url: this.urlCreate, obj: this.paymentRent, notNotifyToast: true };
        if (this.reapeter.length == 0) {
          this.postApi(params).then((response) => { });
        } else {
          this.reapeter.forEach(payment => {
            params.obj.dueDate = payment.dueDate;
            params.obj.value = payment.value;
            this.postApi(params).then((response) => { });
          });
        }
        this.hideModal();
        this.removeLoading(["btnSavePaymentRent"]);
        this.addEvent({ name: "paymentRentUpdated" });
      }
    },
    update(data) {
      this.paymentRent = new PaymentRent();
      this.paymentRent.update(data);
      this.removeLoading([data.id]);
    },
  },
  watch: {
    event: {
      handler(event) {
        if (event.name == "paymentRentCreate") {
          this.resetValidation(this.formName);
          this.paymentRent = new PaymentRent();
        }
        if (event.name == "paymentRentUpdate") this.update(event.data);
      },
      deep: true,
    },
  },
};
</script>
